import axios from "axios";
import { Toast } from "../../../src/util/Toast";
import * as CoinSellerType from "./type";

// GET coinSeller
export const getCoinSeller = () => (dispatch) => {
  axios
    .get(`admin/coinSellers?type=admin`)
    .then((res) => {
      dispatch({
        type: CoinSellerType.GET_COINSELLER,
        payload: res.data.coinSeller,
      });
    })
    .catch((error) => console.log(error));
};

// CREATE coinSeller
export const addCoinSeller = (formData) => (dispatch) => {
  axios
    .post("coinSeller", formData)
    .then((res) => {
      if (res.data.status === true) {
        dispatch({
          type: CoinSellerType.ADD_COINSELLER,
          payload: res.data.coinSeller,
        });
        Toast("success", "Diamond Seller Add Successfully");
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => console.log(error));
};

// UPDATE coinSeller
export const editCoinSeller = (id, fromData) => (dispatch) => {
  axios
    .patch(`coinSeller/${id}`, fromData)
    .then((res) => {
      if (res.data.status === true) {
        dispatch({
          type: CoinSellerType.EDIT_COINSELLER,
          payload: { coinSeller: res.data.coinSeller, id },
        });
        Toast("success", "Diamond Seller Update Successfully");
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => console.log(error));
};

// DELETE Diamond seller
export const deleteCoinSeller = (id) => (dispatch) => {
  axios
    .patch(`coinSeller/disable/${id}`)
    .then((res) => {
      console.log("res", res.data.status);
      if (res.data.status) {
        dispatch({
          type: CoinSellerType.DELETE_COINSELLER,
          payload: { data: res.data.data, id },
        });
        Toast(
          "success",
          `${res.data.data.name}'s is ${
            res.data.data.isDisable === true ? "Active" : "Enable"
          }`
        );
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => console.log(error));
};

// Show coinSeller
export const showCoinSeller = (id) => (dispatch) => {
  axios
    .patch(`coinSeller/show/${id}`)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: CoinSellerType.SHOW_COINSELLER,
          payload: { data: res.data.data, id },
        });
        Toast(
          "success",
          `${res.data.data.name}'s is ${
            res.data.data.isShow === true ? "Active" : "Enable"
          }`
        );
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => console.log(error));
};

export const resetCoinSellerAuthenticator = (id) => (dispatch) => {
  axios
    .post(`coinSeller/${id}/reset-authenticator`)
    .then((res) => {
      if (res.data.status) {
        dispatch({
          type: CoinSellerType.EDIT_COINSELLER,
          payload: { coinSeller: res.data.coinSeller, id },
        });
        Toast("success", res.data.message);
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) =>
      Toast(
        "error",
        error.response?.data?.message ||
          error.response?.data?.error ||
          "Unable to reset the seller authenticator. Please check the backend logs.",
      ),
    );
};

// UPDATE coinSeller
export const AddMoneyByAdmin = (data, id) => (dispatch) => {
  axios
    .post(`coinSeller/adminToCoinSeller/${id}`, data)
    .then((res) => {
      console.log(res.data.coinSeller);
      if (res.data.status === true) {
        dispatch({
          type: CoinSellerType.ADD_MONEY_BY_ADMIN,
          payload: { coinSeller: res.data.coinSeller, id },
        });
        Toast("success", "Add Diamond Successfully");
      } else {
        Toast("error", res.data.message);
      }
    })
    .catch((error) => console.log(error));
};

// GET coinSeller history
export const getCoinSellerHistory = (id) => (dispatch) => {
  axios
    .get(`admin/coinSellers/${id}/history`)
    .then((res) => {
      console.log(res.data);
      dispatch({
        type: CoinSellerType.GET_COINSELLER_HISTORY,
        payload: res.data,
      });
    })
    .catch((error) => console.log(error));
};
